import CurrencySymbol from '@/components/global/CurrencySymbol.vue';
import type { App } from 'vue';
import { defineAsyncComponent } from 'vue';

export function registerGlobalComponents(app: App) {
    app.component('CurrencySymbol', CurrencySymbol);
    app.component(
        'VChart',
        defineAsyncComponent(async () => {
            const mod = await import('@/plugins/echarts');
            mod.setupEcharts();
            return mod.VueECharts;
        }),
    );
}
